import PropTypes from 'prop-types';

const hotelPropType = PropTypes.shape({
  itemRef: PropTypes.string.isRequired,
  cancelled: PropTypes.bool,
  price: PropTypes.number,
  currency: PropTypes.string,
  passenger: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string
  }),
  checkInDate: PropTypes.string,
  jacTravelRef: PropTypes.string,
  hotelId: PropTypes.string,
  eurostarReference: PropTypes.string,
  isDotwBooking: PropTypes.bool
});

export default hotelPropType;
